import { useEffect, useState } from 'react';
import { useCarrier } from '../../contexts/CarrierContext';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabaseClient';
import { toFa } from '../../utils/faFormat';
import JobInspectionModal from './installers/JobInspectionModal';

const STATUS_FA = {
  running: 'در حال بررسی', error: 'ناموفق', done: 'پایان‌یافته',
  compliant: 'منطبق با ضوابط', non_compliant: 'مغایر با ضوابط',
  partially_compliant: 'تا حدی منطبق', insufficient_evidence: 'شواهد ناکافی',
};

export default function RecentInspections({ variant, finishedRun }) {
  const { carrier } = useCarrier();
  const { profile } = useAuth();
  const admin = ['admin', 'super_admin'].includes(profile?.role);
  const [state, setState] = useState({ carrierId: null, rows: [], loading: true, error: null });
  const [selected, setSelected] = useState(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setSelected(null);
    if (!carrier) return () => controller.abort();
    setState({ carrierId: carrier.id, rows: [], loading: true, error: null });
    (async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (controller.signal.aborted) return;
        const res = await fetch(`/api/inspection/recent?variant=${encodeURIComponent(variant)}`, {
          headers: data?.session?.access_token ? { Authorization: `Bearer ${data.session.access_token}` } : {},
          signal: controller.signal,
        });
        const body = await res.json();
        if (controller.signal.aborted) return;
        if (!res.ok || !Array.isArray(body.inspections)) throw new Error('Recent inspections unavailable');
        setState({ carrierId: carrier.id, rows: body.inspections, loading: false, error: null });
      } catch (error) {
        if (!controller.signal.aborted) setState({ carrierId: carrier.id, rows: [], loading: false, error: 'خواندن بازرسی‌های اخیر ناموفق بود.' });
      }
    })();
    return () => controller.abort();
  }, [carrier, variant, finishedRun, retry]);
  if (!carrier) return null;
  // Do not display a previous carrier even for the render before effect cleanup.
  const current = state.carrierId === carrier.id ? state : { rows: [], loading: true, error: null };
  return <div className="iadmin" dir="rtl" style={{ color: 'var(--admin-text-muted, #475569)', marginTop: 24 }}>
    <details>
      <summary style={{ cursor: 'pointer', fontWeight: 600, padding: '12px 0' }}>بازرسی‌های اخیر ({carrier.brand_name})</summary>
      {current.loading ? <p role="status">در حال دریافت بازرسی‌ها...</p> : current.error ? <div role="alert">
        <p>{current.error}</p><button className="iadmin-btn" onClick={() => setRetry((value) => value + 1)}>تلاش دوباره</button>
      </div> : current.rows.length === 0 ? <p>برای {carrier.brand_name} هنوز بازرسی‌ای ثبت نشده است.</p> : <div className="iadmin-list">
        {current.rows.map((row) => <button key={row.id} className="iadmin-job" style={{ width: '100%', textAlign: 'start', color: 'inherit', cursor: 'pointer' }} onClick={() => setSelected({ ...row, carrierId: carrier.id })}>
          <strong><bdi dir="auto">{row.category_label || row.category_id}</bdi></strong>
          <span>وضعیت کلی: {STATUS_FA[row.overall_status] || STATUS_FA[row.status] || 'نامشخص'}</span>
          <span>{toFa(row.finding_count)} مورد</span>
          <span>{row.rulebook_version_no == null ? 'پیش از نسخه‌بندی قواعد' : `نسخهٔ قواعد ${toFa(row.rulebook_version_no)}`}</span>
          <time dateTime={row.created_at}>{row.created_at ? new Date(row.created_at).toLocaleString('fa-IR') : ''}</time>
          {admin && <span>شروع‌کننده: <bdi dir="auto">{row.started_by_name || 'نامشخص'}</bdi></span>}
        </button>)}
      </div>}
    </details>
    {selected?.carrierId === carrier.id && <JobInspectionModal inspectionId={selected.id} variant={selected.variant} onClose={() => setSelected(null)} />}
  </div>;
}
